import { Trans } from "@lingui/macro";

type OcrBetaProps = {
  hideLabel?: boolean;
};
export const OcrBeta = ({ hideLabel }: OcrBetaProps) => {
  return (
    <b style={{ fontSize: "var(--chakra-fontSizes-xs)" }}>
      {!hideLabel && <Trans>OCR</Trans>}
      <sup>
        (<Trans>BETA</Trans>)
      </sup>
    </b>
  );
};
